import { DAIMI_UT_INTRO, DAIMI_UT_SLUG } from '@/content/daimiUtilities'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-first report with a designed page of its own, and the sixth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the outlooks before it (*"referans alarak ilgili sayfayı birebir tıpa
  // tıp aynısını tasarla"*) with a four-part full-page capture of the live page,
  // the cover at 2000px, Figure 1 and the report mockup. See
  // `content/daimiUtilities.ts` and `pages/DaimiUtilities.tsx`.
  ...focus(
    DAIMI_UT_SLUG,
    'Utilities',
    'daimi-report-2026-utilities-cover',
    '2ecf497b-ec39-4a77-b23c-261e1a08a572-digitopia-daimi-2026-report-utilities.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held
  // on the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_UT_INTRO.body,
  layout: 'utilities-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiUtilitiesChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 19
